import { api } from "@/lib/api";
import { useEffect, useMemo } from "react";

export function useSub(roomId: string, userId: string) {
	const sub = useMemo(() => api.chat.ws({ roomId }).subscribe({ query: { userId } }), [roomId, userId]);

	useEffect(() => {
		return () => {
			sub.close();
		};
	}, [sub]);

	return sub;
}
